import React from 'react';
import cssmodules from 'react-css-modules';
import styles from './initiativetypespage.cssmodule.scss';
import { Link } from 'react-router';
import {Panel, FormControl, Button, Nav, NavItem, NavDropdown, MenuItem, Alert, Collapse} from 'react-bootstrap';
var NotificationSystem = require('react-notification-system');
import {injectIntl, intlShape, FormattedRelative} from 'react-intl';



class InitiativeTypesPage extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      currentType : {},
      newType : {
        Title : '',
        TitleEN : '',
        TitleSV : ''
      }
    };

  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
  }

  componentWillReceiveProps(nextProps) { 
    const { typeId } = nextProps;
    const {initiativeTypes} = nextProps;
    var currentType = {};

    initiativeTypes.Types.every((t) => {
      if(t.Id == typeId ){
        currentType = t;
        return false;
      }
      return true;
    })
    this.setState( {currentType : {...currentType}});
  }

  onNewTypeChange(prop, event){
      var value = typeof event === 'object' ? event.target.value : event;
      this.setState({
        newType : {
          ...this.state.newType, [prop] : value
        }
      });

      console.log(prop + "/" + value);
  }

  handleInputChange(propertyName, event){
    var value = typeof event === 'object' ? event.target.value : event;
    if(propertyName === 'IsActive'){
       value = event.target.checked ? true : false;
    }
    let currentType = Object.assign(this.state.currentType, 
          {[propertyName] : value}
    );
    this.setState({
      currentType : currentType
    });
  }

  onSaveType(){
    const {intl} = this.props;
    const t = (message, data = {}) => {
        if(!message) return '';
        return intl.formatMessage({id : message}, data);
    };

    const { actions } = this.props;
    actions.saveInitiativeTypeAction(this.state.currentType).then((payload) => {
      this._notificationSystem.addNotification({
          title : t("Success"),
          message: t('SAVE_INITIATIVE_TYPE_OK') + ': #' + payload.value.Id,
          level: 'success',
          position : 'br'
      });
      actions.fetchInitiativeTypesAction(true);
    });
  }

  onNewTypeAdd (){
    const {intl} = this.props;
    const t = (message, data = {}) => {
        if(!message) return '';
        return intl.formatMessage({id : message}, data);
    };

    const { actions } = this.props;
    actions.saveInitiativeTypeAction({
      ...this.state.newType,
      IsActive : true
    }).then((payload) => {
      this._notificationSystem.addNotification({
          title : t("Success"),
          message: t('NEW_INITIATIVE_TYPE_ADDED') + ': #' + payload.value.Id,
          level: 'success',
          position : 'br'
      });
      actions.fetchInitiativeTypesAction(true);
      this.setState({
        newType : {}
      });
    }, (error) => {
      this.setState({
        addErrorMessage : error.Message,
        addError : true
      });
      setTimeout(()=>{
        this.setState({
          addError : false
        });
      },4000);
    });
  }


  render() {
    const {intl} = this.props;
    const t = (message, data = {}) => {
        if(!message) return '';
        return intl.formatMessage({id : message}, data);
    };
    const {initiativeTypes} = this.props;
    const {currentType} = this.state;
    return (
       
          <div className="container initiativetypespage-component" styleName="initiativetypespage-component">
            <NotificationSystem ref="notificationSystem" />
            <Panel header="Initiative types" className="brand-panel">
            <div className="row">
              <div className="col-md-7">
                <table className="table table-condensed table-striped table-bordered">
                  <thead><tr>
                    <th>#</th>
                    <th>{t('Title_FI')}</th>
                    <th>{t('Title_EN')}</th>
                    <th>{t('Title_SV')}</th>
                    
                    <th>{t('Active')}</th>
                </tr></thead>
                  <tbody>
                    {
                    (initiativeTypes.Types).map((t, idx) => 
                      (<tr key={t.Id}>
                          <td><Link to={"/initiative-types/" + t.Id}>{t.Id}</Link></td>
                          <td>{t.Title} </td>
                          <td>{t.TitleEN} </td>
                          <td>{t.TitleSV} </td>
                          <td><i className={t.IsActive ? "glyphicon glyphicon-ok" : "glyphicon"}/></td>
                      </tr>)
                    )
                  }
                  </tbody>
                  </table>
              </div>
              <div className="col-md-5" >
                {
                  this.state.currentType.Id && (<Panel className="brand-panel" header={'#' + this.state.currentType.Id + ' ' + currentType.Title}>
                  <form>
                      <div className="form-group">
                        <label>{t('Id')}</label>
                        <p className="form-control-static"><strong>&nbsp;&nbsp;&nbsp;{currentType.Id}</strong></p>
                      </div>
                      <div className="form-group required">
                        <label className="control-label">{t('Title_FI')}</label>
                        <input className="form-control" placeholder={t('Title_FI')} value={currentType.Title} onChange={this.handleInputChange.bind(this, 'Title')} />
                      </div>
                      <div className="form-group">
                        <label>{t('Title_EN')}</label>
                        <input className="form-control" placeholder={t('Title_EN')} value={currentType.TitleEN} onChange={this.handleInputChange.bind(this, 'TitleEN')} />
                      </div>
                      <div className="form-group">
                        <label>{t('Title_SV')}</label>
                        <input className="form-control" placeholder={t('Title_SV')} value={currentType.TitleSV} onChange={this.handleInputChange.bind(this, 'TitleSV')} />
                      </div>
                      <div className="checkbox">
                        <label>
                          <input type="checkbox" checked={currentType.IsActive || false} onChange={this.handleInputChange.bind(this, 'IsActive')}/> {t('Is Active')}
                        </label>
                      </div>
                      <button type="button" disabled={!currentType.Title} className="btn btn-default btn-brand" onClick={this.onSaveType.bind(this)}>{t('Save')}</button>
                    </form>
                  </Panel>)
                }
                <Panel className="brand-panel" header={t('Add new initiative type')}>
                  <form>
                     <div className="form-group required">
                        <label className="control-label">{t('Title_FI')}</label>
                        <input className="form-control" placeholder={t('Title_FI')} value={this.state.newType.Title} onChange={this.onNewTypeChange.bind(this, 'Title')} required="true"/>
                     </div>
                     <div className="form-group">
                        <label>{t('Title_EN')}</label>
                       <input className="form-control" placeholder={t('Title_EN')} value={this.state.newType.TitleEN} onChange={this.onNewTypeChange.bind(this, 'TitleEN')}/>
                     </div>
                     <div className="form-group">
                        <label>{t('Title_SV')}</label>
                        <input className="form-control" placeholder={t('Title_SV')} value={this.state.newType.TitleSV} onChange={this.onNewTypeChange.bind(this, 'TitleSV')}/>
                     </div>
                     
                     <Collapse in={this.state.addError || false}>
                        <Alert bsStyle="danger">
                          <span><strong>{t('Error')}!</strong>{t(this.state.addErrorMessage)}</span>
                        </Alert>
                    </Collapse>
                     <button disabled={!(this.state.newType.Title)} onClick={this.onNewTypeAdd.bind(this)} type="button" className="btn btn-default btn-brand">{t('Add')}</button>
                  </form>
                </Panel>
              </div>
            </div>
            </Panel>
          </div>
      
    );
  }
}

InitiativeTypesPage.displayName = 'InitiativeTypesPage';
InitiativeTypesPage.propTypes = {};
InitiativeTypesPage.defaultProps = {};

export default injectIntl(cssmodules(InitiativeTypesPage, styles));



// WEBPACK FOOTER //
// ./components/InitiativeTypes/InitiativeTypesPage.js